import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const TypeDivider = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path d="M3.60001 10.8H20.4V13.8H3.60001V10.8Z" />
  </SvgIcon>
));

TypeDivider.displayName = 'TypeDivider';

export default TypeDivider;
